// Backend contract:
// POST /auth/logout
// Success (200): clears HttpOnly JWT cookie

import { BASE_URL, STORAGE_SESSION_ACTIVE, STORAGE_SUF } from "../constants"
import { deleteStorageVariable } from "../utils/storage"

const suffix = localStorage.getItem(STORAGE_SUF) || ""

export const systemLogout = async (): Promise<void> => {
  try {
    await fetch(`${BASE_URL}/auth/logout-${suffix}`, {
      method: "POST",
      credentials: "include",
    })
  } finally {
    deleteStorageVariable(STORAGE_SESSION_ACTIVE)
  }
}
